import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  startGettingUsersList,
  setUsersAccountList,
  startAddNewUser,
  startGettingUserById,
  setuserDataById,
  startUserAuth,
  startRefreshAccessToken,
  setAuthUser,
  setUserLogout,
  startAuthUserLogout,
  completedFetch,
  completedNewAdd,
  startChangeUserPassword,
  completedChangeUserPassword,
  setUsersAccountFilterList,
  startGettingUsersFilterList,
  startDeleteUser,
  startUploadProfile,
  startResetPassword,
  startGettingEmailOtpList,
  startGettingPhoneOtpList,
  setGettingPhoneOtpList,
  setSecurityQuestionForgot,
  startVerifySecurityCode,
  startSecurityQuestion,
  setSecurityQuestion,
  startAddSecurityQuestion,
  startSecurityQuestionForgot,
  setVerifySecurityCode,
  setGettingEmailOtpList,
  setverifySecurityQuestion,
  setResetPassword
} from "./userAccount.slice.selector";

import { setNotificationAction } from "../NotificationStore/notification.slice.selector";
import {
  getAccountUsers,
  addNewUser,
  getAccountUserById,
  userLogin,
  refresh,
  userLogout,
  changePassword,
  filterUsers,
  getDeleteAccountUserById,
  getUplImageUserById,
  getResetUserImpPassU,
  getPhoneotp,
  getEmailotp,
  getverifyCodeList,
  getverifyOtpCodeList,
  SecurityQData,
  getAddedSecurityQuestionList,
  verifyAddedSecurityQuestionList
} from "../../../Apis/Account/account";

//(1) Watcher
function* startFetchUsersAccountList() {
  yield takeLatest(startGettingUsersList.type, setAccountUserList);
}
//(1) Next
function* setAccountUserList({ payload }) {
  try {
    const response_data = yield call(getAccountUsers, payload);

    yield put(setUsersAccountList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(1) Watcher
function* startFetchFilteredUsersAccountList() {
  yield takeLatest(startGettingUsersFilterList.type, setAccountFilterUserList);
}
//(1) Next
function* setAccountFilterUserList({ payload }) {
  try {
    const response_data = yield call(filterUsers, payload);

    yield put(setUsersAccountFilterList(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2)Wacther
function* startAddingNewUser() {
  yield takeLatest(startAddNewUser.type, callForAddingNewUser);
}
//(2)Next
function* callForAddingNewUser({ payload }) {
  try {
    yield call(addNewUser, payload);
    yield put(completedNewAdd());
    yield put(
      setNotificationAction({
        message: "User Added Successfully",
        variant: "success",
      })
    );
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedNewAdd());
  }
}
//(3) Watcher
function* startFetchLoggedInUsersAccount() {
  yield takeLatest(startUserAuth.type, setLoggedInUser);
}
//(3) Next
function* setLoggedInUser({ payload }) {
  try {
    const response_data = yield call(userLogin, payload);

    yield put(setAuthUser(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(4) Watcher
function* startFetchUsersAccountById() {
  yield takeLatest(startGettingUserById.type, setUserAccountById);
}
//(4) Next
function* setUserAccountById({ payload }) {
  try {
    const response_data = yield call(getAccountUserById, payload);

    yield put(setuserDataById(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}
//(5)Wathcher
function* watchForRefreshAccToken() {
  yield takeLatest(startRefreshAccessToken.type, setLoggedInUserByRefresh);
}
//(5) Next
function* setLoggedInUserByRefresh() {
  try {
    const response_data = yield call(refresh);
    yield put(setAuthUser(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(6)Wathcher
function* watchForUserLogout() {
  yield takeLatest(startAuthUserLogout.type, setLogout);
}
//(6) Next
function* setLogout() {
  try {
    yield call(userLogout);
    yield put(setUserLogout());
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(7)Wacther
function* startChangingPwd() {
  yield takeLatest(startChangeUserPassword.type, callForChangingUserPwd);
}

//(7)Next
function* callForChangingUserPwd({ payload }) {
  // console.log(payload, "pay");
  try {
    yield call(changePassword, payload);
    yield put(completedChangeUserPassword({ message: "Password Changed Successfully" }));
    yield put(
      setNotificationAction({
        message: "Password Changed Successfully",
        variant: "success",
      })
    );
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedChangeUserPassword());
  }
}

//(8) Watcher
function* startDeleteUserList() {
  yield takeLatest(startDeleteUser.type, setDeleteAccountUserList);
}
//(8) Next
function* setDeleteAccountUserList({ payload }) {
  try {
    const response_data = yield call(getDeleteAccountUserById, payload);
    yield put(completedFetch());
    yield put(startGettingUsersList({
      pageIndex: 0,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(9) Watcher
function* startUploadUserImageList() {
  yield takeLatest(startUploadProfile.type, setUploadImageList);
}
//(9) Next
function* setUploadImageList({ payload }) {
  try {
    const response_data = yield call(getUplImageUserById, payload);
    yield put(completedFetch());
    // yield put(startGettingUsersList({
    //   pageIndex: 0,
    //   pageSize: 10,
    // }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}
//(10) Watcher
function* startResetUserImageList() {
  yield takeLatest(startResetPassword.type, setReseList);
}
//(10) Next
function* setReseList({ payload }) {
  try {
    const response_data = yield call(getResetUserImpPassU, payload);
    yield put(setResetPassword("Password Reset Successfully"))
    yield put(
      setNotificationAction({
        message: "Password Reset Successfully",
        variant: "success",
      })
    );
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(11) Watcher
function* startEmailOtpGetList() {
  yield takeLatest(startGettingEmailOtpList.type, setEmailList);
}
//(11) Next
function* setEmailList({ payload }) {
  try {
    const response_data = yield call(getEmailotp, payload);
    yield put(setGettingEmailOtpList("email otp send"));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}
//(12) Watcher
function* startPhoneOtpGetList() {
  yield takeLatest(startGettingPhoneOtpList.type, setPhoneList);
}
//(12) Next
function* setPhoneList({ payload }) {
  try {
    const response_data = yield call(getPhoneotp, payload);
    // console.log(response_data,"2")
    yield put(setGettingPhoneOtpList("phone otp send"));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(13) Watcher
function* startSecurityQuesGetList() {
  yield takeLatest(startSecurityQuestion.type, SecQuestionList);
}
//(13) Next
function* SecQuestionList({ payload }) {
  try {
    const response_data = yield call(SecurityQData, payload);
    yield put(setSecurityQuestion(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(14) Watcher
function* startVerifyCodeList() {
  yield takeLatest(startVerifySecurityCode.type, setVerifyCodeList);
}
//(14) Next
function* setVerifyCodeList({ payload }) {
  try {
    const response_data = yield call(getverifyOtpCodeList, payload);
    // console.log(response_data, "res")
    yield put(setVerifySecurityCode("otp successfull"));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(15) Watcher
function* startAddSecQues() {
  yield takeLatest(startAddSecurityQuestion.type, setAddSecurityQ);
}
//(15) Next
function* setAddSecurityQ({ payload }) {
  try {
    const response_data = yield call(getAddedSecurityQuestionList, payload); 
    yield put(
      setNotificationAction({
        message: "Security Questions Added Successfully",
        variant: "success",
      })
    );
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(16) Watcher
function* startAddSecQuesForg() {
  yield takeLatest(startSecurityQuestionForgot.type, setAddSecurityQF);
}
//(16) Next
function* setAddSecurityQF({ payload }) {
  try {
    const response_data = yield call(verifyAddedSecurityQuestionList, payload); 
    yield put(setverifySecurityQuestion("Security Question verified"));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

///Accumulator
export default function* accountUsersSaga() {
  yield all([
    call(startFetchUsersAccountList),
    call(startFetchFilteredUsersAccountList),
    call(startAddingNewUser),
    call(startFetchUsersAccountById),
    call(startFetchLoggedInUsersAccount),
    call(watchForUserLogout),
    call(watchForRefreshAccToken),
    call(startChangingPwd),
    call(startDeleteUserList),
    call(startUploadUserImageList),
    call(startResetUserImageList),
    call(startEmailOtpGetList),
    call(startPhoneOtpGetList),
    call(startSecurityQuesGetList),
    call(startVerifyCodeList),
    call(startAddSecQues),
    call(startAddSecQuesForg),
  ]);
}
